import { useCustomToast } from '../../../components';
import apiClient from '../../../services/apiClient';
import { TransformFilters } from '../../../utils';

const storedAuth = JSON.parse(localStorage.getItem('auth') || '{}');
const userId = storedAuth?.user?.id;
const { showToast } = useCustomToast();

export const InventoryViewAPI = {
  
  fetchMovements: async ({ queryKey }: any) => {
  try {
    const [, filters] = queryKey;
    const transformedFilters = TransformFilters({
      ...filters,
      new_responsible_id: userId,
    });
    const { data } = await apiClient.get('/api/petition/transfer', {
      params: {
        paginate: true,
        page: filters?.page,
        ...transformedFilters,
      },
    });
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al obtener los movimientos.';
    throw error;
  }
},

createConceptPetition: async (conceptData: FormData) => {
  try {
    const { data } = await apiClient.post(
      '/api/petition/concept',
      conceptData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al crear la solicitud de concepto.';
    showToast('error', message);
    console.error('Error en createConceptPetition:', error);
    throw error;
  }
},

generateConceptPDF: async (conceptId: string) => {
  try {
    const { data } = await apiClient.get(`/api/petition/transfer/pdf/${conceptId}`);

    const { url, filename } = data || {};

    if (!url) {
      throw new Error('No se encontró la URL del PDF en la respuesta.');
    }

    const fileResponse = await fetch(url);
    const blob = await fileResponse.blob();

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', filename || 'comprobante_transferencia.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href); 

    showToast('success', 'PDF generado con éxito.');
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al generar el PDF.';
    showToast('error', message);
    console.error('Error en generateConceptPDF:', error);
    throw error;
  }
},



downloadConceptDocuments: async (id: string) => {
 try {
      const response = await apiClient.get<Blob>(
        `/api/petition/transfer/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `exportacion_traslado_funcionario.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      throw error;
    }
},


evaluateConceptPetitionItems: async (evaluationId: string, payload: any) => {
  try {
    const { data } = await apiClient.post(
      `/api/petition/concept/evalItems/${evaluationId}`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al evaluar los ítems.';
    showToast('error', message);
    console.error('Error en evaluateConceptPetitionItems:', error);
    throw error;
  }
},

fetchParameters: async (keys: string[], filters?: Record<string, string>) => {
  try {
    const queryParams = keys.map((key) => `keys[]=${encodeURIComponent(key)}`).join('&');
    let filterParams = '';
    if (filters) {
      filterParams = Object.entries(filters)
        .map(([key, value]) => `filter[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`)
        .join('&');
    }
    const queryString = `${queryParams}${filterParams ? '&' + filterParams : ''}`;
    const { data } = await apiClient.get(`api/utils/select-tables?${queryString}`);
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al obtener parámetros.';
    showToast('error', message);
    console.error('Error en fetchParameters:', error);
    return null;
  }
},

fetchTransferAdditions: async (evaluationId: string) => {
  try {
    const { data } = await apiClient.get(`/api/asset/related/${evaluationId}`);
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al obtener adiciones de la transferencia.';
    showToast('error', message);
    console.error('Error en fetchTransferAdditions:', error);
    throw error;
  }
},

updateTransferStatus: async (
  transferId: number | string,
  payload: {
    observations: string;
    items: { id: string; status_id: string; observations: string }[];
  }
) => {
  try {
    const { data } = await apiClient.put(
      `/api/petition/transfer/manageItems`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al actualizar estado de los ítems.';
    showToast('error', message);
    console.error('Error en updateTransferStatus:', error);
    throw error;
  }
},

updateEvaluationItems: async (evaluationId: string, payload: any) => {
  try {
    const { data } = await apiClient.put(
      `/api/petition/transfer/${evaluationId}`,
      payload
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al actualizar la evaluación.';
    showToast('error', message);
    console.error('Error en updateEvaluationItems:', error);
    throw error;
  }
},
};
